/**
 * Created by Mark on 24/04/2017.
 */

import React from 'react';
import {Alert , Button , ButtonToolbar , Row , Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group' // ES6

const Panel = React.createClass({

    render: function(){

        var AdvanceButton;
        var ComponentClass = this.props.component;

        return <div>
                    <ComponentClass data={this.props.data} />
               </div>;
    }

});

export default Panel


// WEBPACK FOOTER //
// ./src/components/profile/panel.js